// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_2l01zku"};


//////////////////
// WEBPACK FOOTER
// ./template/components/CountrySelector/Backdrop.css
// module id = ./template/components/CountrySelector/Backdrop.css
// module chunks = client.sitechrome